import { fetchGaupaChallenge } from './gaupa/challenge';
import { fetchAuthMeta, exchangeChallenge } from './auth-api';
import { consumeOAuthTokenFromStorage, navigateToAppRootAfterOAuth } from './gaupa/login';

/** Read domain JWT from ?token= and strip from the URL. */
export function readAndStripTokenFromUrl() {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');
  if (!token) return null;

  url.searchParams.delete('token');
  const clean = url.pathname + url.search + url.hash;
  history.replaceState(null, '', clean);
  return token;
}

/** Domain JWT from URL query or the /redirect handoff stash. */
export function readOAuthDomainToken() {
  return readAndStripTokenFromUrl() ?? consumeOAuthTokenFromStorage();
}

/** If Gaupa OAuth returned a domain JWT, exchange for a Booga app session. */
export async function tryOAuthSessionFromUrl() {
  const domainJwt = readOAuthDomainToken();
  if (!domainJwt) return null;

  // Gaupa domain JWTs are standard three-part JWTs — ignore unrelated ?token= values.
  if (domainJwt.split('.').length !== 3) {
    console.warn('[auth] Ignoring non-JWT OAuth token');
    return null;
  }

  const { gaupaHost, publicKey } = await fetchAuthMeta();
  if (!gaupaHost || !publicKey) {
    throw new Error('Auth meta missing gaupaHost or publicKey');
  }
  const { challenge } = await fetchGaupaChallenge(gaupaHost, publicKey, domainJwt);
  const login = await exchangeChallenge(challenge);
  // Prefer root URL after a successful exchange (in case we booted on /redirect).
  navigateToAppRootAfterOAuth();
  return login;
}

/** Handle OAuth return via custom URL scheme (Capacitor deep link). */
export async function tryOAuthSessionFromDeepLink(url: string) {
  try {
    const parsed = new URL(url);
    const token = parsed.searchParams.get('token');
    if (!token || token.split('.').length !== 3) return null;

    const { gaupaHost, publicKey } = await fetchAuthMeta();
    if (!gaupaHost || !publicKey) return null;
    const { challenge } = await fetchGaupaChallenge(gaupaHost, publicKey, token);
    return exchangeChallenge(challenge);
  } catch (err) {
    console.warn('[auth] deep link OAuth exchange failed:', err);
    return null;
  }
}
